import { Check } from "lucide-react";
import { Reveal, SectionLabel } from "../../lib/motion";
import { ABOUT_POINTS, PROPERTY, IMAGES } from "../../data";

export const About = () => {
  return (
    <section id="property" className="py-24 md:py-32 bg-warm-light/50 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <Reveal>
            <SectionLabel>About the Property</SectionLabel>
            <h2 className="font-serif text-4xl md:text-5xl font-light text-navy mt-4 leading-tight">
              A quiet wooded homesite, thoughtfully prepared
            </h2>
            <p className="mt-6 text-warm leading-relaxed">
              {PROPERTY.name} {PROPERTY.lot} rests on approximately 0.91 acres within an established
              waterfront community in {PROPERTY.county}.
            </p>

            <div className="mt-8 space-y-4">
              {ABOUT_POINTS.map((p, i) => (
                <Reveal key={i} delay={i * 0.06}>
                  <div data-testid={`about-point-${i}`} className="flex items-start gap-4">
                    <div className="mt-0.5 w-7 h-7 rounded-full bg-forest/10 flex items-center justify-center shrink-0">
                      <Check size={15} className="text-forest" />
                    </div>
                    <p className="text-navy/90 leading-relaxed">{p}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="relative">
              <div className="rounded-3xl overflow-hidden shadow-[0_24px_70px_-24px_rgba(11,37,69,0.3)]">
                <img
                  src={IMAGES.aerial}
                  alt="Wooded Virginia waterfront homesite"
                  loading="lazy"
                  className="w-full h-[540px] object-cover"
                />
              </div>
              <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl border border-warm-border p-6 max-w-[230px]">
                <div className="label-caps text-[10px] text-water">Current County Assessment</div>
                <div className="mt-1 font-serif text-3xl text-navy">{PROPERTY.assessment}</div>
                <div className="text-xs text-warm mt-1">{PROPERTY.taxMap}</div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
